module.exports = __webpack_public_path__ + "img/Fooocus.216b1beb.svg";